module.exports = __webpack_public_path__ + "img/se-skatt-moms.67ba0654.png";